import * as I from "immutable";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import {trackEvent} from "metrics";

import FieldError from "v2/components/FieldError";
import FieldGroup from "v2/components/FieldGroup";
import {AppData} from "v2/api/Records";
import api from "v2/api";
import {isDesktop} from "utils";

import ModalForm from "v2/components/responsive/ModalForm";

export default class CancelDestinationForm extends Component {
  static contextTypes = {
    appData: PropTypes.instanceOf(AppData),
    onUpdateDateData: PropTypes.func,
    onUpdateRouteData: PropTypes.func,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
      routeId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
    router: PropTypes.object,
  }

  static propTypes = {
    modal: PropTypes.bool,
    onCancel: PropTypes.func,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedReason: null,
      errors: I.Map(),
    };
  }

  handleSelectChange = (item) => {
    this.setState({
      selectedReason: item && item.value,
    });
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.setState({
      submitted: true,
    });

    const {
      onUpdateDateData,
      onUpdateRouteData,
      params: {date, id},
    } = this.context;
    const {modal, onCancel} = this.props;
    const {selectedReason} = this.state;

    api()
      .post(this.apiUrl, {
        "cancel_reason": selectedReason,
      })
      .then(() => {
        onUpdateRouteData(null, () => {
          modal && onCancel();

          trackEvent("Cancel Destination", ["Destination", "Cancel Destination", id], {
            Date: date,
            ID: id,
          });

          onUpdateDateData();
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          const {data} = err.response;
          this.setState({
            errors: Array.isArray(data) ? I.Map({message: data[0]}) : I.Map(data),
            submitted: false,
          });
        } else {
          this.setState({
            errors: I.Map({
              message: "Server Error. Please contact engineering team if error will repeat after page reload.",
            }),
            submitted: false,
          });
          Raven.captureException(err);
        }
      });
  }

  get apiUrl() {
    const {params: {routeId, id}} = this.context;
    return `/routes/${routeId}/destinations/${id}/cancel`;
  }

  renderContent() {
    const {selectedReason, errors} = this.state;
    const {appData} = this.context;

    const options = appData.cancelReason.map((value, key) => (
      {value: key, label: value}
    )).toArray();

    return (
      <div className="form-horizontal">
        <FieldGroup error={errors}>
          <label className="col-xs-12 col-sm-3 control-label">Reason:</label>
          <div className="col-xs-12 col-sm-9">
            <Select
              autoBlur
              autofocus={isDesktop()}
              clearable={false}
              name="cancel-reason-select"
              onChange={this.handleSelectChange}
              options={options}
              placeholder="Select reason"
              value={selectedReason} />
            <FieldError>{errors}</FieldError>
          </div>
        </FieldGroup>
      </div>
    );
  }

  render() {
    const {submitted} = this.state;
    return (
      <ModalForm
        btnSubmitDisabled={submitted}
        btnSubmitLabel="Cancel Destination"
        modalTitle="Cancel Destination"
        onSubmit={this.handleSubmit}
        pageTitle="Cancel Destination"
        {...this.props}>
        {this.renderContent()}
      </ModalForm>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/CancelDestinationForm.js
 **/